import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-col',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-col{display:block;flex:1 1 0;margin-right:20px;min-width:0}.mcrai-col:last-child{margin-right:0}.mcrai-col[flex-2]{flex:2 2 0}.mcrai-col[flex-3]{flex:3 3 0}.mcrai-col[flex-4]{flex:4 4 0}.mcrai-col[flex-5]{flex:5 5 0}.mcrai-col[flex-6]{flex:6 6 0}.mcrai-col[flex-7]{flex:7 7 0}.mcrai-col[flex-8]{flex:8 8 0}.mcrai-col[flex-9]{flex:9 9 0}.mcrai-col[flex-10]{flex:10 10 0}.mcrai-col[flex-auto]{flex:0 0 auto}.mcrai-col[vertical-top]{display:flex;align-items:flex-start}.mcrai-col[vertical-center]{display:flex;align-items:center}.mcrai-col[vertical-bottom]{display:flex;align-items:flex-end}.mcrai-col[horizontal-left]{display:flex;justify-content:flex-start}.mcrai-col[horizontal-center]{display:flex;justify-content:center}.mcrai-col[horizontal-right]{display:flex;justify-content:flex-end}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mcrai-col]': 'true'
  }
})
export class ColComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
